"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _UILayer = _interopRequireDefault(require("../layer/UILayer"));

var _focusStylesListener = require("../listeners/focusStylesListener");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

// Based on https://github.com/twbs/bootstrap/blob/v3.3.6/dist/js/bootstrap.js
function measureScrollbar() {
  var scrollDiv = document.createElement('div');
  scrollDiv.className = 'uiFullScreen-scrollbar-measure';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

var _default = _react.default.createClass({
  displayName: "UIFullScreen",
  propTypes: {
    children: _react.PropTypes.element.isRequired,
    rootNode: _react.PropTypes.object,
    Transition: _component.default
  },
  statics: {
    layerCount: 0,
    NO_SCROLL_CLASS: 'uiFullScreenBackground',
    originalBodyPaddingRight: ''
  },
  getInitialState: function getInitialState() {
    return {
      clonedChild: null
    };
  },
  componentWillMount: function componentWillMount() {
    this._lastFocus = document.activeElement;

    var child = _react.default.Children.only(this.props.children);

    this.setState({
      clonedChild: _react.default.cloneElement(child, {
        open: true
      })
    });
  },
  componentDidMount: function componentDidMount() {
    this.constructor.layerCount += 1;

    if (this.constructor.layerCount === 1) {
      this.disableBackgroundScrolling();
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.children !== nextProps.children) {
      this.setState({
        clonedChild: _react.default.cloneElement(_react.default.Children.only(nextProps.children), {
          open: true
        })
      });
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.constructor.layerCount -= 1;
  },
  handleCloseComplete: function handleCloseComplete() {
    if (this._lastFocus) {
      if ((0, _focusStylesListener.isPageInKeyboardMode)()) {
        this._lastFocus.focus();
      }

      this._lastFocus = null;
    }

    if (this.constructor.layerCount === 0) {
      this.restoreBackgroundScrolling();
    }
  },
  disableBackgroundScrolling: function disableBackgroundScrolling() {
    var _this = this;

    this.addFauxScrollbar();
    [document.documentElement, document.body].forEach(function (el) {
      return el.classList && el.classList.add(_this.constructor.NO_SCROLL_CLASS);
    });
  },
  restoreBackgroundScrolling: function restoreBackgroundScrolling() {
    var _this2 = this;

    this.removeFauxScrollbar();
    [document.documentElement, document.body].forEach(function (el) {
      return el.classList && el.classList.remove(_this2.constructor.NO_SCROLL_CLASS);
    });
  },
  addFauxScrollbar: function addFauxScrollbar() {
    var bodyHasScrollbar = document.body.clientWidth < window.innerWidth;

    if (bodyHasScrollbar) {
      var scrollbarWidth = measureScrollbar() + "px"; // To avoid changing the body width when we disable scrollbar, we replace
      // the scrollbar with padding of equal width.

      this.constructor.originalBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollbarWidth;
    }
  },
  removeFauxScrollbar: function removeFauxScrollbar() {
    document.body.style.paddingRight = this.constructor.originalBodyPaddingRight;
  },
  render: function render() {
    return _react.default.createElement(_UILayer.default, (0, _extends2.default)({}, this.props, {
      onCloseComplete: this.handleCloseComplete
    }), this.state.clonedChild);
  }
});

exports.default = _default;
module.exports = exports.default;